import React from 'react'
import SeoHead from '../components/SeoHead'
import BookingForm from '../components/BookingForm'
import GallerySection from '../components/GallerySection'

export default function BookingPage() {
  return (
    <div className="w-full bg-white">
      <SeoHead
        title="Book rundvisning - Emmerske Efterskole"
        description="Book en personlig og uforpligtende rundvisning på Emmerske Efterskole. Vælg en ledig dato og tidspunkt online og oplev vores værksteder, fællesskab og ordblindestøtte."
      />

      {/* Underside Hero Banner */}
      <section className="relative bg-[#36454F] text-white pt-36 sm:pt-44 lg:pt-52 pb-24 sm:pb-32 lg:pb-36 min-h-[440px] sm:min-h-[500px] flex items-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="/_assets/dsc01025-0_65feac6f.jpg"
            alt=""
            aria-hidden="true"
            className="w-full h-full object-cover object-center"
          />
          <div
            className="absolute inset-0"
            style={{
              background:
                'linear-gradient(to right, rgba(54,69,79,0.85) 0%, rgba(54,69,79,0.65) 50%, rgba(47,111,115,0.45) 100%)',
            }}
          />
        </div>

        <div className="background-blob -bottom-24 -right-24 bg-white/10" aria-hidden="true" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-4 relative z-10 w-full text-center">
          <span className="font-['Shadows_Into_Light'] text-2xl sm:text-3xl md:text-4xl text-[#DCEEF2] -rotate-2 inline-block drop-shadow-sm">
            Oplev efterskolelivet ved selvsyn
          </span>

          <h1 className="font-['Plus_Jakarta_Sans'] text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black text-white tracking-tight leading-tight max-w-4xl mx-auto">
            Book en personlig rundvisning
          </h1>

          <p className="text-[#DCEEF2] text-base sm:text-lg leading-relaxed max-w-2xl mx-auto font-medium">
            Den bedste måde at mærke efterskolelivet på er at opleve det selv. Vi inviterer familien
            indenfor til en personlig rundvisning, hvor I ser skolen og kan stille alle jeres
            spørgsmål.
          </p>
        </div>
      </section>

      {/* Main Booking Form */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <div className="max-w-4xl mx-auto">
          <BookingForm />
        </div>
      </main>

      {/* Galleri nederst */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 sm:pb-24 w-full">
        <GallerySection
          galleryRef="faellesskab"
          customTitle="Oplev hverdagen på skolen"
          customDescription="Få et indtryk af vores elever, faciliteter og det trygge fællesskab inden jeres besøg."
        />
      </section>
    </div>
  )
}
